// extracted by mini-css-extract-plugin
export default {"earn":"Earn_earn__AyXyD","earnHeader":"Earn_earnHeader__6MRhr"};